<template>
  <div>
    <el-dialog
      title="Maaş İşle"
      :visible="MaasModal"
      center
      width="40%">
      <a @click="$emit('MaasModal', true)" class="ModalKapat"><i class="el-icon-close"></i></a>
      <Yukleniyor :data="lo"></Yukleniyor>
      <el-form :rules="FormHata" :model="Form"
               @submit.prevent.native="Submit"
               ref="GiderForm">
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="Kategori" prop="Kategori_id">
              <el-cascader
                collapse-tags
                :options="Kategoriler"
                v-model="Form.Kategori_id"
                filterable></el-cascader>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Evrak No" prop="eNo">
              <el-input v-model="Form.eNo"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="Tutar" prop="Tutar">
              <el-input v-model="Form.Tutar"/>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="Borçlanma Tarihi" prop="tTarihi">
              <el-date-picker
                v-model="Form.tTarihi"
                type="date"
                placeholder=""
                format="dd.MM.yyyy">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="Son Ödeme Tarihi" prop="sTarihi">
              <el-date-picker
                v-model="Form.sTarihi"
                type="date"
                placeholder=""
                format="dd.MM.yyyy">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="Açıklama" prop="Aciklama">
              <el-input v-model="Form.Aciklama"/>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" v-if="!lo" size="medium" @click="Submit()" icon="el-icon-check">
          Maaş İşle
        </el-button>
      </div>
    </el-dialog>


  </div>
</template>
<script>
import Yukleniyor from "../../../Doc/Yukleniyor";

export default {
  components: {Yukleniyor},
  props: ["MaasModal", "Cari_id", "Bina_id", "Maas"],
  data() {
    return {
      MakbuzDetayModal: false,
      mNo: null,
      TekrarKapali: false,
      OdemeKapali: false,
      lo: false,
      Yetki: false,
      ModalOlayi: false,
      Kaydet: true,
      Sayfa: {
        ButtonAdi: 'Kaydet',
        Adi: 'Gider İşle',
        DuzenleAdi: this.$t('eGenel.10'),
        SilAdi: this.$t('eGenel.11'),
        Arama: this.$t('eGenel.9'),
        Menu: [
          {Adi: 'Excel Yükle', Link: '/muhasebe/gider/excel'},
          {Adi: 'Abonelik İşle', Link: '/muhasebe/gider/abonelik'},
        ],
        MenuDisplay: true,
      },
      Form: {
        Bina_id: null,
        Cari_id: null,
        Kategori_id: null,
        sTarihi: null,
        tTarihi: null,
        Tutar: null,
        Aciklama: null,
        eNo: null,
        Tur: 1
      },
      FormHata: {
        Cari_id: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
        Kategori_id: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
        Bina_id: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
        tTarihi: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
        sTarihi: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
        Tutar: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
        Aciklama: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
      },
      Kategoriler: [],
      AltToplam: null
    }
  },
  methods: {
    Submit() {
      this.$refs['GiderForm'].validate((valid) => {
        if (valid) {
          this.lo = true;
          this.$store.dispatch("Post", {...this.Form, path: 'muhasebe/gider/gider'})
            .then(response => {
              this.lo = false;
              if (response.Durum == "OK") {
                this.$message.success(response.Mesaj);
                this.Form.Tarih = response.Tur;

                this.$emit('MaasModal', true);

              } else {
                this.$message.error(response.Mesaj);
                this.hata = response.Hata;
              }
            })
        }
      })
    },

    SayfaYukle() {
      this.lo = true
      this.$store.dispatch("Get", {path: 'muhasebe/kategori'})
        .then(response => {
          this.lo = false
          if (response.Durum === 'OK') {
            this.Kategoriler = response.Liste
          } else {
            this.$message.error(response.Mesaj);
            this.hata = response.Hata;
          }
        });

    }
  },
  created() {

    this.Yetki = this.$store.getters.Yetki.muhasebe == 2 ? true : false;
    this.$store.commit("SayfaBilgi", this.Sayfa);
    this.SayfaYukle();
    //+'.'+Gun.getMonth()+'.'+Gun.getFullYear()
    var Gun = new Date();
    var AySonu = new Date(Gun.getFullYear(), Gun.getMonth() + 1, 0);

    this.Form = {
      Bina_id: this.Bina_id,
      Cari_id: this.Cari_id,
      Kategori_id: null,
      sTarihi: AySonu,
      tTarihi: Gun,
      Tutar: this.Maas,
      Aciklama: null,
      eNo: null,
      Tur: 1
    }
  },
  computed: {
    Tutar() {
      return this.Form.Tutar
    },

  },
  watch: {
    Tutar() {
      if (this.Form.Tutar) this.Form.Tutar = this.Form.Tutar.replace(",", ".");
      //console.log(this.Form.Tutar);
    },

  }

}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Pack/Muhasebe/cari/MaasIsle.vue